import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _class, _class2, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbPopup } from "abreact/incubator/ui/popup/AbPopup";
import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
import { AbLocalToolbar, AbLocalToolbarGroup } from "abreact/incubator/ui/toolbar/AbLocalToolbar";
import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { AbMarkdownExtensions } from "abreact/input/markdown/AbMarkdownExtensions";
import { AbButton } from "abreact/misc/AbButton";
import { AbImage } from "absdk/commons/ui/misc/AbImage";
import { action, makeObservable, observable } from "mobx";
import { observer } from "mobx-react";
import React from "react";

// The person in the markdown editor.

/**
 * The component that renders a person in the AbMarkdownEditor.
 *
 * @deprecated Replace {@link AbMarkdownEditor} with {@link AbMarkdownLexical} markdown editor and its child {@link PersonComponent}
 */
export let AbMarkdownPersonCmp = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, observer(_class = (_class2 = class AbMarkdownPersonCmp extends React.Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "showSelection", _descriptor, this);
    _defineProperty(this, "spanRef", null);
    this.showSelection = false;
    makeObservable(this);
  }
  onClick(event) {
    this.showSelection = true;
    this.props.containingEditor.setSelection(this.props.blockKey, this.props.start);
  }
  editPerson(event) {
    this.showSelection = false;
    this.props.containingEditor.editPerson();
  }
  deletePerson(event) {
    this.showSelection = false;
    this.props.containingEditor.deleteLink();
  }
  render() {
    const data = this.props.contentState.getEntity(this.props.entityKey).getData();
    let extension;
    try {
      // Any extension registered?
      extension = AbMarkdownExtensions.markdownPersonExtension.get();
    } catch (e) {
      extension = undefined;
    }
    let displayName = data.displayName;
    if (displayName.length === 0) displayName = data.id;
    return /*#__PURE__*/React.createElement("span", {
      className: CssUtils.composeClassNames("ab-markdown-person-cmp", this.showSelection && "ab-markdown-person-selection"),
      ref: x => this.spanRef = x,
      onClick: this.onClick,
      "data-entity-key": this.props.entityKey,
      "data-offset-key": this.props.offsetKey
    }, "\u200b", extension && extension.render({
      displayName,
      id: data.id
    }, this.props.children), !extension && /*#__PURE__*/React.createElement("span", {
      className: "ab-markdown-person-default"
    }, /*#__PURE__*/React.createElement(AbImage, {
      image: "absdk:nav-users"
    }), displayName), this.showSelection && /*#__PURE__*/React.createElement(AbPopup, {
      className: "ab-markdown-popup-toolbar",
      origin: this.spanRef || undefined,
      positioner: PopupUtils.VERTICAL_FIXED_SIZE_POSITIONER,
      flushContent: true,
      overlay: false,
      onClose: action(() => this.showSelection = false),
      closeOnBackgroundClick: true
    }, /*#__PURE__*/React.createElement(AbLocalToolbar, {
      type: "stand-alone"
    }, /*#__PURE__*/React.createElement(AbLocalToolbarGroup, null, /*#__PURE__*/React.createElement(AbButton, {
      onClick: this.editPerson,
      label: "Edit"
    }), /*#__PURE__*/React.createElement(AbButton, {
      onClick: this.deletePerson,
      label: "Delete"
    })))));
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showSelection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "onClick", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "onClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "editPerson", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "editPerson"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deletePerson", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "deletePerson"), _class2.prototype), _class2)) || _class);
//# sourceMappingURL=AbMarkdownPersonCmp.js.map
